import { costTypeItems, convertCostTypeToText } from "../../utils/enum";

const CostSelect = ({ placeholder = "نوع", value, ...otherProps }) => {
  return (
    <select className="form-control-lg form-control" {...otherProps}>
      <option value="" selected hidden>
        {placeholder}
      </option>
      {costTypeItems.map((item) => (
        <option key={item} value={item} selected={item === value}>
          {convertCostTypeToText(item)}
        </option>
      ))}
    </select>
  );
};

export default CostSelect;
